import { render, staticRenderFns } from "./layoutB.vue?vue&type=template&id=b5eccf48&scoped=true&"
import script from "./layoutB.vue?vue&type=script&lang=js&"
export * from "./layoutB.vue?vue&type=script&lang=js&"
import style0 from "./layoutB.vue?vue&type=style&index=0&id=b5eccf48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eccf48",
  null
  
)

export default component.exports